import { cn, RadioItem } from '@ntconsult/aluma-react';
import type { ReactNode } from 'react';

type Props = {
  value: string;
  label: ReactNode;
  children?: ReactNode;
  /** Clique ou Enter/Espaço na opção, marcada ou não (R3). As setas só mudam a marcada. */
  onEscolher?: (valor: string) => void;
  /** Ainda não dá para escolher (listas do Axiis carregando, R8): `aria-disabled`, sem `disabled`. */
  indisponivel?: boolean;
};

/** Item de rádio em forma de cartão (spec 33 R3). */
export function OpcaoCartao({ value, label, children, onEscolher, indisponivel = false }: Props) {
  return (
    <RadioItem
      value={value}
      aria-disabled={indisponivel || undefined}
      className={cn(
        'flex h-full min-h-14 w-full items-start rounded-md border border-border px-4 py-3',
        'has-[:checked]:border-brand-primary has-[:checked]:bg-brand-primary/5',
        indisponivel && 'cursor-wait opacity-50',
      )}
      label={
        <span className="flex flex-col gap-1">
          <span className="font-medium">{label}</span>
          {children}
        </span>
      }
      // O `onValueChange` do rádio nativo não dispara ao clicar na opção já marcada (R3).
      onClick={(e) => {
        if (indisponivel) return e.preventDefault();
        onEscolher?.(value);
      }}
      onKeyDown={(e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        // Enter dentro do `<form>` enviaria o formulário; Espaço viraria um clique.
        e.preventDefault();
        if (!indisponivel) onEscolher?.(value);
      }}
    />
  );
}
